
export const CodigoNotaria = '3';
export const UrlApi = 'https://sinfony.com.co/api/public/api/';

export const GenesysEnvironment = 'prod';
export const GenesysDeploymentId = '97625f69-1be5-446a-b797-d4d8f264e251';

export const SocialLinks = {
	facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/',
	instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/',
	x: process.env.REACT_APP_SOCIAL_X || 'https://www.x.com/',
};
